import { Injectable } from '@angular/core'
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { DynamicRoutesService } from '../services/dynamic-routes.service'

/** This guards prevents route from being called, when the initialization of the dynamic routes is finished. */
@Injectable({
  providedIn: 'root'
})
export class DynRouteInitCompGuard implements CanActivate {
  constructor(private dynamicRoutesService: DynamicRoutesService) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.dynamicRoutesService.dynamicRoutesAreInitialized$.pipe(map((initialized) => !initialized))
  }
}
